import type { ConfigurationContextValue } from "./ConfigurationContext";

// Branding defaults
export const defaultTitle = "Finturf CRM";
export const defaultFinturfLogo =
  "https://media.licdn.com/dms/image/v2/D560BAQFmyWfy0HOd4g/company-logo_200_200/B56ZxDxwYSKQAI-/0/1770663643088/finturf_logo?e=1775088000&v=beta&t=vM3qA4UwkjHbj-08by2vApe5_bdpYkcnW_RSuVFQW_4";
export const defaultDarkModeLogo = defaultFinturfLogo;
export const defaultLightModeLogo = defaultFinturfLogo;
export const defaultFavicon = defaultFinturfLogo;

// Company defaults
export const defaultCompanyName = "Finturf";
export const defaultCompanyAddress = "";
export const defaultCompanyPhone = "";
export const defaultCompanyEmail = "";
export const defaultCompanyWebsite = "";

export const defaultCurrency = "USD";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

export const defaultDealStages = [
  { value: "opportunity", label: "Opportunity" },
  { value: "proposal-sent", label: "Proposal Sent" },
  { value: "in-negociation", label: "In Negotiation" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
  { value: "delayed", label: "Delayed" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "other", label: "Other" },
  { value: "copywriting", label: "Copywriting" },
  { value: "print-project", label: "Print project" },
  { value: "ui-design", label: "UI Design" },
  { value: "website-design", label: "Website design" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Lunch" },
  { value: "meeting", label: "Meeting" },
  { value: "follow-up", label: "Follow-up" },
  { value: "thank-you", label: "Thank you" },
  { value: "ship", label: "Ship" },
  { value: "call", label: "Call" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  // Branding
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
  favicon: defaultFavicon,

  // Company
  companyName: defaultCompanyName,
  companyAddress: defaultCompanyAddress,
  companyPhone: defaultCompanyPhone,
  companyEmail: defaultCompanyEmail,
  companyWebsite: defaultCompanyWebsite,

  // Business Settings
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
};
